import { TDocume } from './../models/TDocume.model';
import { Injectable } from '@angular/core';
import { ROUTE_COMERCIAL } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AnyRecord } from 'dns';

@Injectable({
  providedIn: 'root'
})
export class TDocumeRestService {

  constructor(private apiService: ApiService,
    private http: HttpClient) {
  }

  insertarTDocume(data: TDocume): Observable<any> {
    this.apiService.setUrlPathApi('tdocume');
    return this.apiService.executePostJson(data).pipe();
  }

  actualizarTDocume(data: TDocume): Observable<any> {
    this.apiService.setUrlPathApi('tdocume');
    return this.apiService.executePutJson(data).pipe();
  }

  eliminarTDocume(codigo: any): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/');
    return this.apiService.executeDeleteJson(`${codigo}`)
  }

  obtenerTDocume(codigo: any): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/');
    return this.apiService.execGetQueryJson(`${codigo}`).pipe();
  }

  buscarTDocume(codigos: any): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/buscar?');
    return this.apiService.execGetQueryJson(`codigos=${codigos}`).pipe();
  }

  obtenerCuenta(tipdoc: any, codprov: any, codmon: any): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/');
    return this.apiService.execGetQueryJson(`${tipdoc}/cuenta?codprov=${codprov}&codmon=${codmon}`).pipe();
  }

  eliminarClase(tipdoc: any, clase: any, codmon: any): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/');
    return this.apiService.executeDeleteJson(`${tipdoc}/${clase}/${codmon}`)
  }

  obtenerCuenta2(tipdoc: AnyRecord): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/');
    return this.apiService.execGetQueryJson(`${tipdoc}/cuenta`).pipe();
  }

  BuscarClases(): Observable<any> {
    this.apiService.setUrlPathApi('tdocume/');
    return this.apiService.execGetQueryJson(`clases`).pipe();
  }
  updateNumbco(data:any){
    this.apiService.setUrlPathApi('dcta-100/actualiza-numbco');
    return this.apiService.executePutJson(data).pipe();
  }
  obtenerDocumento(tipdoc:any,docume:any){
    this.apiService.setUrlPathApi(`dcta-100/${tipdoc}/${docume}`);
    return this.apiService.execGetJson();
  }
}
